import { useId } from "react";

const PdfIcon = ({ width = 84, height = 81, ...props }) => {
  const uid = useId().replace(/:/g, "");
  const clipId = `pdf-icon-clip-${uid}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 84 81'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d='M20 1L46.5811 1L71 25.7236V73C71 76.866 67.866 80 64 80L20 80C16.134 80 13 76.866 13 73V8C13 4.13401 16.134 1 20 1Z'
          fill='#F3F6FA'
          stroke='#D5D9DF'
          strokeWidth='2'
        />
        <path
          d='M46 2.02502V20.325C46 23.6387 48.6863 26.325 52 26.325L70 26.325'
          stroke='#D5D9DF'
          strokeWidth='2'
          strokeLinecap='round'
        />
      </g>
      <rect x='3' y='39' width='48' height='32' rx='4' fill='#E5252A' />
      <path
        d='M10.4711 62V48.9091L15.6359 48.9091C16.6288 48.9091 17.4747 49.0987 18.1736 49.478C18.8724 49.853 19.4051 50.375 19.7716 51.044C20.1423 51.7088 20.3277 52.4759 20.3277 53.3452C20.3277 54.2145 20.1402 54.9815 19.7652 55.6463C19.3902 56.3111 18.8468 56.8288 18.1352 57.1996C17.4278 57.5703 16.5713 57.7557 15.5656 57.7557L12.2737 57.7557V55.5376L15.1182 55.5376C15.6508 55.5376 16.0897 55.446 16.4349 55.2628C16.7843 55.0753 17.0443 54.8175 17.2147 54.4893C17.3895 54.157 17.4768 53.7756 17.4768 53.3452C17.4768 52.9105 17.3895 52.5312 17.2147 52.2074C17.0443 51.8793 16.7843 51.6257 16.4349 51.4467C16.0855 51.2635 15.6423 51.1719 15.1054 51.1719L13.2389 51.1719V62L10.4711 62ZM26.7931 62L22.1524 62V48.9091L26.8314 48.9091C28.1482 48.9091 29.2817 49.1712 30.232 49.6953C31.1823 50.2152 31.9131 50.9631 32.4245 51.9389C32.9401 52.9148 33.1979 54.0824 33.1979 55.4418C33.1979 56.8054 32.9401 57.9773 32.4245 58.9574C31.9131 59.9375 31.178 60.6896 30.2192 61.2138C29.2646 61.7379 28.1226 62 26.7931 62ZM24.9202 59.6286L26.678 59.6286C27.4962 59.6286 28.1844 59.4837 28.7426 59.1939C29.3051 58.8999 29.727 58.446 30.0083 57.8324C30.2938 57.2145 30.4365 56.4176 30.4365 55.4418C30.4365 54.4744 30.2938 53.6839 30.0083 53.0703C29.727 52.4567 29.3073 52.005 28.749 51.7152C28.1908 51.4254 27.5026 51.2805 26.6844 51.2805L24.9202 51.2805V59.6286ZM35.2751 62V48.9091L43.9427 48.9091V51.1911L38.0429 51.1911V54.3104L43.3675 54.3104V56.5923L38.0429 56.5923V62L35.2751 62Z'
        fill='white'
      />
      <defs>
        <clipPath id={clipId}>
          <rect width='60' height='81' fill='white' transform='translate(12)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PdfIcon;
